window.site = (window.site || {});

/**
 * Init AjaxPagination related scripts
 * @class Site
 * @static
 */
site.HoffmanLifeHero = (function HoffmanLifeHero() {
  /**
   * jQuery elements
   * @private
   */

  /**
   * Has the class been initialized?
   * @private
   */
  let inited = false;

  /**
   * Initializes the class.
   * @public
   */
  const init = function () {

    // Abort if already initialized
    if (inited) {
      return false;
    }

    inited = true;

    const $heroText = document.querySelector('.hoffman-life-lp .hoffman-life-hero .hero-text');

    if ($heroText) {
      const sentences = JSON.parse($heroText.dataset.sentences).map(el => el.text)
      new TypeIt($heroText, {
        strings: sentences,
        cursor: false,
        speed: 50,
        lifeLike: true,
        nextStringDelay: 100
      }).go();
    }

    return true;
  };


  // Expose public methods & properties
  return {
    init: init,
  };

}().init());
